module.exports = __webpack_public_path__ + "static/media/program_step_1_en.4651918b.svg";